<script setup lang="ts">
  import type { IdfJourneyTemplateGrondbank } from '@/types/idf-journey-product'
  import { FormInput, UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    label: string
    placeholder: string
    buttonLabel: string
  }>()

  defineEmits<{
    fetch: []
  }>()

  const model = defineModel<IdfJourneyTemplateGrondbank | null>('modelValue', { required: true })
</script>

<template>
  <div class="quality-container">
    <div class="quality-code">
      <FormInput :label="label" :placeholder="placeholder" v-model="model!.drieDeligCode" />
    </div>
    <div class="code-button">
      <UiButton @click="$emit('fetch')" variant="prominent" size="medium" :label="buttonLabel" />
    </div>
  </div>
</template>

<style scoped>
  .quality-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    align-items: end;
  }

  .quality-code {
    flex-grow: 1;
  }

  .code-button {
    margin-bottom: var(--spacing-s);
  }
</style>
